import { useState, useContext, useEffect } from 'react'

import { Typography } from '@mui/material'

import { AppContext } from '/providers/app-context'


import { getFreeCreditsDetails } from '/providers/clients-api'


const FreeCredits = () => {

  const { apiSource, apiKey } = useContext(AppContext)
  const [nextTopup, setNextTopup] = useState()
  const [freeCredits, setFreeCredits] = useState(200)

  useEffect(() => {
    getFreeCredits()
  },[])

  const getFreeCredits = async () => {
    const c = await getFreeCreditsDetails({ apiSource, apiKey })

    if (c.ok) {
      setNextTopup(c.topupDate)
      setFreeCredits(c.credits)
    }
  }

  return (
    <>
      <div className='flex flex-row p-5'>
          <div className='flex flex-col gap-5 p-3 items-center max-w-[400px]'>

            <Typography variant='h4'>Free Credits</Typography>

            <p>All customers get a free credit top up each month. These do not roll-over to the following month.</p>

            <p>On your billing day, your free credit allowance is reset to {freeCredits} credits.</p>
            <p>Any unused free credits from the previous month are replaced. Purchased credits are held separately and are not reduced by this reset.</p>
            <p>Free credits are always used before purchased credits.</p>

            <p>Next topup</p>
            <Typography variant='h4' className='link'>{nextTopup}</Typography>            

            <p>Maximum free credits</p>
            <Typography variant='h4' className='link'>{freeCredits} credits</Typography>            

          </div>
      </div>
    </>
  )
}

export default FreeCredits
